import get from 'lodash/get';

const getMakerImageURL = (maker, makerImageList) => {
  if (typeof maker !== 'string' || !maker.trim().length) {
    return null;
  }

  const makerNormalized = maker.replace(/\s/g, '_').toLowerCase();
  const makerImage = makerImageList.find(image => image.includes(makerNormalized));

  return makerImage && [{ 6: `/static/img/cars/maker/${makerImage}` }];
};

const getImageByMaker = (make, trovit) => {
  if (!make) {
    return null;
  }

  const makerImageList = get(trovit, ['imagePlaceHolders', 'cars', 'images']);
  if (!makerImageList) {
    return null;
  }

  const makerImageURL = getMakerImageURL(make, makerImageList);
  if (!makerImageURL) {
    return null;
  }

  return makerImageURL;
};

export default getImageByMaker;



// WEBPACK FOOTER //
// ./app/utils/imagePlaceHolders/cars.js